import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => {console.log(initialState);setState({ ...initialState });}
  
  
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message);
    
    emailjs
      .sendForm("service_za3b1ev", "template_ntmwit8", e.target, "7gXnc8HUJDryAzQ_N")
      .then(
        (result) => {
          console.log(result.text);
          clearState();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Contacteer ons</h2>
                <p>
                 Vul onderstaand formulier in om ons een e-mail te sturen. We nemen zo snel mogelijk contact met u op.
                </p>
              </div>
              <form name="sentMessage" validate="true" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Naam"
                        required
                        value={name}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        value={email}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Bericht"
                    required
                    value={message}
                    onChange={handleChange}
                    style={{resize:"none"}}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg">
                  Verstuur
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>
              <p>
                <span style={{color:'#d9df69'}}>
                  <i className="fa fa-map-marker" style={{color:'#d9df69'}}></i> Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span style={{color:'#d9df69'}}>
                  <i className="fa fa-phone" style={{color:'#d9df69'}}></i> GSM
                </span>
                <a href={`tel:${props.data ? props.data.phone : "loading"}`}>{props.data ? props.data.phone : "loading"}</a>
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span style={{color:'#d9df69'}}>
                  <i className="fa fa-envelope-o" style={{color:'#d9df69'}}></i> Email
                </span>
                <a href={`mailto:${props.data ? props.data.email : "loading"}`}> {props.data ? props.data.email : "loading"}</a>
               
              </p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.instragram : "/"}>
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2025 {""}
            <a href="https://www.linkedin.com/in/maxim-bauwelinck-a0a6a433b/" rel="nofollow">
              Maxim Bauwelinck
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
